import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import { PictureAsPdf, Download, Close } from '@mui/icons-material';

interface PdfViewerDialogProps {
  open: boolean;
  url: string | null;
  title?: string;
  onClose: () => void;
}

const PdfViewerDialog: React.FC<PdfViewerDialogProps> = ({ open, url, title, onClose }) => {
  const handleDownload = () => {
    if (!url) return;
    const link = document.createElement('a');
    link.href = url;
    link.download = `${title || 'relatorio'}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{ sx: { height: '90vh' } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PictureAsPdf fontSize="small" />
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" noWrap>
            {title || 'Visualizador de PDF'}
          </Typography>
        </Box>
        <IconButton color="inherit" size="small" title="Baixar" onClick={handleDownload}>
          <Download fontSize="small" />
        </IconButton>
        <IconButton color="inherit" size="small" title="Fechar" onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, display: 'flex', overflow: 'hidden', bgcolor: 'grey.300' }}>
        {url && (
          <iframe
            key={url}
            src={url}
            title="Visualizador de PDF"
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PdfViewerDialog;
